// extracted by mini-css-extract-plugin
module.exports = {"container":"DRHEo","icon":"_1x_-w","iconContainer":"_3lE1N"};